module.exports = __webpack_public_path__ + "img/line-qr-code@2x.1a399582.png";